export default "__VITE_ASSET__D8Ebp9jX__"